// Polyfill for process (needed by some libraries in browser environment)
if (typeof process === 'undefined') {
  window.process = {
    env: {
      NODE_ENV: 'development'
    }
  };
}

import React from "react";
import ReactDOM from "react-dom";

import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
// teste
// teste
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0";
//import "./assets/css/demo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/css/admin-dashboard.css";
import {pegarParametroUrl} from './utils/utils.js';
import AdminLayout from "layouts/Admin.js";
import InicioLayout from "layouts/Inicio";
import AdminDashboardLayout from "layouts/AdminDashboardLayout.js";
import LoginPage from "views/admin/LoginPage.js";
import AdminDashboard from "views/admin/AdminDashboard.js";
import { isAuthenticated } from "./utils/adminAuth.js";
import VariaveisGlobais from "variaveis_globais/variaveis_globais";
import {IntlProvider} from 'react-intl';

// Protected Route Component for Admin Dashboard
const ProtectedRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated()) {
          return (
            <AdminDashboardLayout>
              <Component {...props} />
            </AdminDashboardLayout>
          );
        } else {
          return <Redirect to="/adm-gsconnect/login" />;
        }
      }}
    />
  );
};

const isLocalhost = document.location.href.includes('localhost');
const hasAuthParams = pegarParametroUrl('idEmpresa') != null && pegarParametroUrl('idUsuario') != null && pegarParametroUrl('token') != null;

if (!isLocalhost && !hasAuthParams) {
  // Render without auth params - only admin dashboard available
  ReactDOM.render(
    <IntlProvider locale='pt'>
    <BrowserRouter>
      <Switch>
        {/* Admin Dashboard Routes - Available without authentication params */}
        <Route path="/adm-gsconnect/login" exact component={LoginPage} />
        <ProtectedRoute path="/adm-gsconnect" exact component={AdminDashboard} />
        <Redirect from="/" to="/adm-gsconnect/login" />
      </Switch>
    </BrowserRouter>
    </IntlProvider>,
    document.getElementById("root")
  );
} else {
  if (document.location.href.includes('localhost')) {
    VariaveisGlobais.idClinica = '1028';
    VariaveisGlobais.idUsuario = 13284
    VariaveisGlobais.token = 'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiI1IiwidW5pcXVlX25hbWUiOiJSaWNhcmRvIiwibmJmIjoxNzQ2MDE2OTM5LCJleHAiOjE4NDA3MTEzMzksImlhdCI6MTc0NjAxNjkzOSwiaXNzIjoiZ3Nkb2N0b3IuY29tLmJyIiwiYXVkIjoiaHR0cHM6Ly93d3cuZ3Nkb2N0b3IuY29tLmJyIn0.M3d0Fb4lzCrJUWCSMIgeGntH2EPsHMIdk6JQ5r247Cy68doKwCh22E-xEKZWo0aXwiDSpkuaJ33rcUNgcDUc3g'
  } else {
    VariaveisGlobais.idClinica = pegarParametroUrl('idEmpresa');
    VariaveisGlobais.idUsuario = pegarParametroUrl('idUsuario');
    VariaveisGlobais.token = pegarParametroUrl('token');
    VariaveisGlobais.usuario = pegarParametroUrl('usuario');
  }

  ReactDOM.render(
    <IntlProvider locale='pt'>
    <BrowserRouter>
      <Switch>
        {/* Admin Dashboard Routes - Must be before /admin routes */}
        <Route path="/adm-gsconnect/login" exact component={LoginPage} />
        <ProtectedRoute path="/adm-gsconnect" exact component={AdminDashboard} />
        
        {/* Existing Routes */}
        {/* <Route path='/inicio' render={(props) => <InicioLayout {...props} /> } /> */}
        <Route path="/qrcode" render={(props) => <InicioLayout {...props} /> } />
        <Route path="/admin" exact render={() => <Redirect to="/admin/home" />} />
        <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
        <Route path="/" exact render={() => <Redirect to="/admin/home" />} />
        
      </Switch>
    </BrowserRouter>
    </IntlProvider>,
    document.getElementById("root")
  ); // teste
}
